import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useGamesNavigation } from "@state/hooks/games/useGamesNavigation";

export default function HeaderSportsBettingNavItem() {
	return <HeaderSportsBettingNavLi />;
}

const HeaderSportsBettingNavLi = observer(
	function HeaderSportsBettingNavLi() {
		const { handleGamesRedirection } = useGamesNavigation();
		const { t } = useTranslation();

		return (
			<li className="nav--primary__item">
				<div className="nav--primary__link" onClick={handleGamesRedirection}>
					{t("COMMON.SPORTS_BETTING")}
				</div>
			</li>
		);
	}
);
